import React, { useState, useEffect } from "react";

const VideoThumb = ({ src, startTime, alt, imgClassName, wrapperClassName, onClick, showBadge, showOverlay }) => {
  const [thumb, setThumb] = useState(null);

  useEffect(() => {
    if (!src) return;
    const video = document.createElement("video");
    video.muted = true;
    video.playsInline = true;
    video.preload = "metadata";

    const onSeeked = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth || 640;
        canvas.height = video.videoHeight || 360;
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        setThumb(canvas.toDataURL("image/jpeg", 0.85));
      } catch (e) {}
      video.src = "";
    };

    const onMeta = () => {
      video.currentTime = startTime > 0 ? startTime : 0.1;
    };

    video.addEventListener("loadedmetadata", onMeta);
    video.addEventListener("seeked", onSeeked);
    video.src = src;

    return () => {
      video.removeEventListener("loadedmetadata", onMeta);
      video.removeEventListener("seeked", onSeeked);
      video.src = "";
    };
  }, [src, startTime]);

  return (
    <div
      className={`video-cover-wrapper${wrapperClassName ? " " + wrapperClassName : ""}`}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {thumb ? (
        <img className={imgClassName} src={thumb} alt={alt} />
      ) : (
        <div className={`video-thumb-placeholder${imgClassName ? " " + imgClassName : ""}`} />
      )}
      {showOverlay !== false && (
        <div className="video-cover-overlay">
          <div className="video-cover-play-btn">&#9654;</div>
        </div>
      )}
      {showBadge && <span className="video-cover-badge">&#9654; VIDEO</span>}
    </div>
  );
};

export default VideoThumb;
